import { MOCK_RESOURCE_LIBRARY_DATA_FLAG } from 'utils/highschoolHelpers'

// Add in the flag name of flags as strings.
// REQUIRED for any flags to work. Subscribe here for the app to listen to any of these flags and get values
// For example:
// ['feature_learn-2790_react-poc_01-2020']
export default [
  'feature_learn-16048_WEBINAR_GATING',
  MOCK_RESOURCE_LIBRARY_DATA_FLAG,
  'feature_LEARN-18248-hs-family-resources',
  'feature_learn-18453-hs-student-extension-activities',
  'high-school-snapshot-role-count-and-layout-update',
  'feature_learn-18822-HS-user-progress-reporting',
  'feature_LEARN-20164-k5-site-selection',
  'feature_LEARN-20168_playbook-journey-for-learn-multi-site',
  'show-monitor-dropdown',
  'feature_LEARN-24549_Tier_2_Reporting',
]
